import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from './Card'
import PropTypes from 'prop-types';
import { LanguageConsumer, Translate, TranslateExt } from '../contexts/LanguageContext';

export const TransferOption = (props) => {
    console.log({ props, outside:props.Item.outside });
    let acceptedCurrencies = props.Item.acceptedCurrencies.map(item => (
        <span key={item} className="badge badge-light m-1">{TranslateExt(item)}</span>
    ))
    return (
        <LanguageConsumer>
            {() => (
                <div key={props.Item.url} className="col-md-3 fadeIn">
                    <Card Title={props.Item.title} className="text-center p-2">
                        <img src={"assets/psp-logo/" + (props.Item.logo || "defaultlogo.svg")} alt="" height="30" className="mt-3" />
                        <p className="text-muted mt-3">{Translate("Accepted Currencies")}</p>
                        <p className="mt-3">
                            {acceptedCurrencies}
                        </p>
                        <p className="text-muted mt-3"> {Translate("Processing Time / Fee")}</p>
                        <p className="mt-3">
                            <span className="badge badge-light m-1">{Translate(props.Item.processingTime)}</span><span className="badge badge-light m-1">{Translate(props.Item.fee)}</span>
                        </p>
                        {props.Item.outside ?
                            (<a href={props.Item.url} target="_blank" rel="noopener noreferrer" className="btn btn-info mt-3">{Translate(props.ButtonTitle)}</a>) :
                            (<Link to={`${props.Url}${props.Item.url}`} className="btn btn-info mt-3">{Translate(props.ButtonTitle)}</Link>)}
                    </Card>
                </div>
            )}
        </LanguageConsumer>
    )
}

TransferOption.prototype = {
    ButtonTitle: PropTypes.string
};
TransferOption.defaultProps = {
    Logo: "defaultlogo.svg",
    ButtonTitle: "Deposit Now",
    Url: "/deposit/"
};
